import { useCallback } from 'react';

import {
    DESKTOP_FORM_FACTOR,
    MOBILE_FORM_FACTOR,
    TABLET_FORM_FACTOR
} from './constants';
import { TFormFactorProps } from './types';
import { useCurrentFormFactor } from './useCurrentFormFactor';

export const useGetDataByFormFactor = () => {
    const currentFormFactor = useCurrentFormFactor();

    return useCallback(({
        mobile,
        tablet,
        desktop,
        fallback
    }: TFormFactorProps): any => {
        switch (currentFormFactor) {
            case MOBILE_FORM_FACTOR: {
                return mobile || fallback;
            }

            case TABLET_FORM_FACTOR: {
                return tablet || fallback;
            }

            case DESKTOP_FORM_FACTOR: {
                return desktop || fallback;
            }

            default: {
                return fallback;
            }
        }
    }, [currentFormFactor]);
};
